"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "21", height: "21", viewBox: "0 0 21 21", className: "Icon nav-help", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M10.5 19.711a9.211 9.211 0 1 0 0-18.422 9.211 9.211 0 0 0 0 18.422zm0 1.289C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5 16.299 21 10.5 21z", fillRule: "nonzero" }),
            _react2.default.createElement("path", { d: "M9.65 12.802c.005-.707.066-1.197.183-1.47.117-.273.424-.633.921-1.082.483-.57.827-1.009 1.031-1.316.205-.307.308-.678.308-1.112 0-.516-.138-.914-.414-1.191-.275-.278-.669-.417-1.18-.417-.444 0-.822.12-1.134.362-.312.241-.468.596-.468 1.064 0 0-.025.839-.71.839-.686 0-.686-.883-.686-.883-.015-.785.262-1.414.83-1.887C8.897 5.236 9.62 5 10.498 5c.96 0 1.706.245 2.237.735.531.49.797 1.173.797 2.05 0 .63-.172 1.205-.515 1.727-.344.521-.799 1.055-1.364 1.6-.263.264-.423.5-.48.71-.055.21-.083.536-.083.98H9.65zm1.492 2.998H9.636v-1.52h1.506v1.52z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/nav-help.js
// module id = 1818
// module chunks = 0